module.exports = __webpack_public_path__ + "img/agi.92f0d2a2.png";